import { cn } from "@/lib/utils";

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
  /** Container genişliği: narrow (max-w-4xl), wide (max-w-7xl), full (w-full) */
  size?: "narrow" | "wide" | "full";
  /** Padding: true (varsayılan px-4), false (padding yok) */
  padding?: boolean;
}

/**
 * Sayfa içeriği için temel container bileşeni
 * Tutarlı spacing ve max-width sağlar
 */
export function PageContainer({
  children,
  className,
  size = "wide",
  padding = true,
}: PageContainerProps) {
  return (
    <div
      className={cn(
        "mx-auto w-full",
        {
          "max-w-4xl": size === "narrow",
          "max-w-7xl": size === "wide",
          // full için max-width yok
        },
        padding && "px-4 sm:px-6 lg:px-8",
        className
      )}
    >
      {children}
    </div>
  );
}

interface PageHeaderProps {
  title: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}

/**
 * Sayfa başlığı bileşeni
 * Tutarlı başlık ve açıklama stili sağlar
 */
export function PageHeader({ title, description, children, className }: PageHeaderProps) {
  return (
    <div className={cn("mb-8", className)}>
      <h1 className="text-3xl font-bold tracking-tight md:text-4xl">{title}</h1>
      {description && <p className="text-muted-foreground mt-2 text-lg">{description}</p>}
      {children}
    </div>
  );
}

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  /** Vertical padding */
  spacing?: "sm" | "md" | "lg";
}

/**
 * Sayfa bölümü bileşeni
 * Tutarlı dikey boşluklar sağlar
 */
export function Section({ children, className, spacing = "md" }: SectionProps) {
  return (
    <section
      className={cn(
        {
          "py-8": spacing === "sm",
          "py-12 md:py-16": spacing === "md",
          "py-16 md:py-24": spacing === "lg",
        },
        className
      )}
    >
      {children}
    </section>
  );
}
